import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import CeldaOrdenable from '../UI/CeldaOrdenable.js';
import * as Funciones from '../funciones/FuncionesEstadio.js';
import * as FuncionesOrdenamiento from '../funciones/FuncionesOrdenamiento.js';
import FiltrosEstadios from './FiltrosEstadios.js';
import styles from './BaseEstadios.module.css';
import { TituloPagina } from '../funciones/Funciones.js';

const BaseEstadios = (props) => {
  const [searchParameters] = useSearchParams();
  const [lista, setLista] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [ordenamientos, setOrdenamientos] = useState([
    { campo: FuncionesOrdenamiento.CamposOrdenamiento.NOMBRE, ascendente: true },
  ]);

  useEffect(() => {
    document.title = TituloPagina(BaseEstadios.name);
  }, []);

  const onBuscando = () => {
    setLista([]);
    setBuscando(true);
  };

  const onListaCargada = (estadios) => {
    setBuscando(false);
    setLista(estadios);
  };

  return (
    <div>
      <FiltrosEstadios
        searchParams={searchParameters}
        onBuscando={onBuscando}
        onListaCargada={onListaCargada}
        hasResults={lista && lista.length > 0}
      />
      {!buscando && lista && lista.length === 0 && (
        <div className={`${styles.mensajeSinDatos}`}>No se encontraron estadios</div>
      )}
      {lista && lista.length > 0 && (
        <React.Fragment>
          <table width="60%" className={`${styles.listaEstadios}`}>
            <thead>
              <tr>
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.NOMBRE}
                  label="Nombre"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerNombre}
                  title="Click para ordenar. Shift+Click para ordenamiento secundario"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.LOCALIDAD}
                  label="Localidad"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerLocalidad}
                  title="Click para ordenar. Shift+Click para ordenamiento secundario"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.INAUGURACION}
                  label="Inauguración"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerInauguracion}
                  title="Click para ordenar. Shift+Click para ordenamiento secundario"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.PROPIETARIO}
                  label="Propietario"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerPropietario}
                  title="Click para ordenar. Shift+Click para ordenamiento secundario"
                />
              </tr>
            </thead>
            <tbody>
              {FuncionesOrdenamiento.ordenarListaMultiNivel(
                lista,
                ordenamientos,
                FuncionesOrdenamiento.configEstadios
              ).map((estadio) => {
                return (
                  <tr key={estadio.id}>
                    <td>
                      <Link to={'/estadio/' + estadio.id}>{estadio.nombre}</Link>
                    </td>
                    <td>{estadio.localidad && estadio.localidad.nombre}</td>
                    <td align="center">{estadio.anioInauguracion}</td>
                    <td>{Funciones.PropietariosEstadio(estadio)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </React.Fragment>
      )}
    </div>
  );
};

export default BaseEstadios;
